import { useMemo } from "react";
import { Column, useTable } from "react-table";
import { IconButton, TextField } from "@funcional/react-ui";
import {
  IFormField,
  IFormFieldOption,
} from "@pbm/registration-policies/contracts";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { UseFormRegister } from "react-hook-form";
import { ReactTable } from "@funcional/react-table-ui";

interface FormFieldOptionListProps {
  register: UseFormRegister<IFormField>;
  addOption: Function;
  editOption: Function;
  deleteOption: Function;
  data: IFormFieldOption[];
}

export const FormFieldOptionList = ({
  register,
  addOption,
  editOption,
  deleteOption,
  data,
}: FormFieldOptionListProps) => {
  const columns: Column<IFormFieldOption>[] = useMemo(
    () =>
      [
        {
          Header: "Código",
          accessor: "value",
          Cell: ({ row, value }: any) => {
            return (
              <TextField
                defaultValue={value}
                {...register(`options.${row.index}.value` as any)}
                size="small"
                placeholder="Código"
              />
            );
          },
        },
        {
          Header: "Descrição",
          accessor: "text",
          Cell: ({ row, value }: any) => {
            return (
              <TextField
                size="small"
                placeholder="Descrição"
                defaultValue={value}
                {...register(`options.${row.index}.text` as any)}
              />
            );
          },
        },
      ] as Column<IFormFieldOption>[],
    [register]
  );

  const tableInstance = useTable({ columns, data }, (hooks: any) => {
    hooks.visibleColumns.push((columns: any) => [
      ...columns,
      {
        id: "crud",
        Header: () => (
          <IconButton size="small" title="Adicionar opção" onClick={addOption}>
            <AddIcon />
          </IconButton>
        ),
        Footer: () => (
          <IconButton size="small" title="Adicionar opção" onClick={addOption}>
            <AddIcon />
          </IconButton>
        ),
        Cell: ({ row }: any) => (
          <div className="flex">
            <IconButton
              size="small"
              title="Editar"
              onClick={() => editOption(row)}
            >
              <EditIcon />
            </IconButton>

            <IconButton
              size="small"
              title="Excluir"
              onClick={() => deleteOption(row)}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        ),
      },
    ]);
  });

  return <ReactTable compact footer tableInstance={tableInstance} />;
};
